import { Html } from '@custom/schema';
import clsx from 'clsx';
import { selectAll } from 'hast-util-select';
import React from 'react';
import { FadeUp } from '../../Molecules/FadeUp';
export var unorderedItems = function() {
    return function(tree) {
        selectAll('ul > li', tree).forEach(function(node) {
            node.properties.unordered = true;
        });
    };
};
export function BlockMarkup(props) {
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50,
        className: "container-page my-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx([
            'prose lg:prose-xl',
            'marker:text-[#111928]',
            'marker:font-bold'
        ])
    }, /*#__PURE__*/ React.createElement(Html, {
        plugins: [
            unorderedItems
        ],
        components: {
            blockquote: function(param) {
                var children = param.children;
                return /*#__PURE__*/ React.createElement("blockquote", {
                    className: "relative border-l-0 pl-0"
                }, /*#__PURE__*/ React.createElement("svg", {
                    width: "32",
                    height: "24",
                    viewBox: "0 0 32 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, /*#__PURE__*/ React.createElement("path", {
                    d: "M18.6893 24V14.1453C18.6893 6.54 23.664 1.38533 30.6667 0L31.9933 2.868C28.7507 4.09066 26.6667 7.71867 26.6667 10.6667H32V24H18.6893ZM0 24V14.1453C0 6.54 4.99733 1.384 12 0L13.328 2.868C10.084 4.09066 8 7.71867 8 10.6667L13.3107 10.6667V24H0Z",
                    fill: "#9CA3AF"
                })), children);
            }
        },
        markup: props.markup
    })))));
}
